import { globalApi as api } from '../../api';

export const createStates = async (AddStates) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/create_state', AddStates, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};


export const fetchStates = async () => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get('/get_states', {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const updateStates = async (id, updateStatesData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/update_state/${id}`, updateStatesData, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const deleteStates = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.delete(`/delete_state/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

